import { docStem as stem, extractFileBlocks, type FileBlock } from "../api/fileBlocks";
import { app } from "./app.svelte";

// Le fichier d'origine visé par une modification (bloc ````file:….docx ou
// ````file:….pdf en JSON) : pièce jointe de la conversation, la plus récente
// d'abord, sinon document de la bibliothèque, les documents actifs d'abord.
// Le modèle nomme sa source comme il l'a lue ; on tolère extension, casse et
// séparateurs — mais pas le format : un .pdf ne prend jamais un .docx.

/** Blocs de fichier des réponses de la conversation, dans l'ordre : une
 *  révision qui prolonge la précédente y retrouve celle-ci. */
export function conversationFileBlocks(): FileBlock[] {
  return app.currentMessages.filter((m) => m.role === "assistant").flatMap((m) => extractFileBlocks(m.content));
}

export function findOriginal(source: string, ext: "docx" | "pdf" = "docx"): string | null {
  const ofKind = (name: string) => name.toLowerCase().endsWith(`.${ext}`);
  const candidates: { name: string; original: string }[] = [];
  for (const m of [...app.currentMessages].reverse()) {
    for (const d of m.attachedDocs ?? []) {
      if (d.original && ofKind(d.name)) candidates.push({ name: d.name, original: d.original });
    }
  }
  const active = new Set(app.activeDocIds);
  const library = app.docs
    .filter((d) => d.original && ofKind(d.name))
    .sort((a, b) => Number(active.has(b.id)) - Number(active.has(a.id)));
  for (const d of library) candidates.push({ name: d.name, original: d.original! });

  const want = stem(source);
  const match =
    candidates.find((c) => stem(c.name) === want) ??
    (want ? candidates.find((c) => stem(c.name).includes(want) || want.includes(stem(c.name))) : undefined) ??
    (candidates.length === 1 ? candidates[0] : undefined);
  return match?.original ?? null;
}
